
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("hiTOb"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("hiTOb", function(module, exports) {

let $c98f687de97175c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c98f687de97175c5$var$load("5wVuh"),
    $c98f687de97175c5$var$load("4NznW"),
    $c98f687de97175c5$var$load("2YX4L"),
    $c98f687de97175c5$var$load("byHKo"),
    $c98f687de97175c5$var$load("2Sb1F"),
    $c98f687de97175c5$var$load("10E5t"),
    $c98f687de97175c5$var$load("gknbb"),
    $c98f687de97175c5$var$load("6iz6l"),
    $c98f687de97175c5$var$load("4SCW2"),
    $c98f687de97175c5$var$load("36QeB"),
    $c98f687de97175c5$var$load("9q75n"),
    $c98f687de97175c5$var$load("iYHbd"),
    $c98f687de97175c5$var$load("7aMek"),
    $c98f687de97175c5$var$load("3q2Ng"),
    $c98f687de97175c5$var$load("jRpDi"),
    $c98f687de97175c5$var$load("3GuOt"),
    $c98f687de97175c5$var$load("jbM5v"),
    $c98f687de97175c5$var$load("dek7I"),
    $c98f687de97175c5$var$load("dYtBN"),
    $c98f687de97175c5$var$load("kNV5Y"),
    $c98f687de97175c5$var$load("6SWFK"),
    $c98f687de97175c5$var$load("9aQIt"),
    $c98f687de97175c5$var$load("5zapo"),
    $c98f687de97175c5$var$load("3MYQs"),
    $c98f687de97175c5$var$load("XZauT"),
    $c98f687de97175c5$var$load("4S1SF"),
    $c98f687de97175c5$var$load("jiFtb"),
    $c98f687de97175c5$var$load("lm9Lt"),
    $c98f687de97175c5$var$load("9atVd"),
    $c98f687de97175c5$var$load("9wPDc"),
    $c98f687de97175c5$var$load("1MWOL"),
    $c98f687de97175c5$var$load("6fQco"),
    $c98f687de97175c5$var$load("aOY32"),
    $c98f687de97175c5$var$load("7jSfd"),
    $c98f687de97175c5$var$load("4HZlX"),
    $c98f687de97175c5$var$load("kDqHr"),
    $c98f687de97175c5$var$load("6wr18"),
    $c98f687de97175c5$var$load("gT8XU"),
    $c98f687de97175c5$var$load("8bhm4"),
    $c98f687de97175c5$var$load("ffEVr"),
    $c98f687de97175c5$var$load("7EorR"),
    $c98f687de97175c5$var$load("8HygH"),
    $c98f687de97175c5$var$load("G9L45"),
    $c98f687de97175c5$var$load("kuFG2"),
    $c98f687de97175c5$var$load("hhss7"),
    $c98f687de97175c5$var$load("Wowvf"),
    $c98f687de97175c5$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("1ykvG"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("1ykvG", function(module, exports) {

let $1218e04d5a9ee7e8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1218e04d5a9ee7e8$var$load("6wr18"),
    $1218e04d5a9ee7e8$var$load("7aMek"),
    $1218e04d5a9ee7e8$var$load("8bhm4"),
    $1218e04d5a9ee7e8$var$load("ffEVr"),
    $1218e04d5a9ee7e8$var$load("2tIxk"),
    $1218e04d5a9ee7e8$var$load("dLq4a"),
    $1218e04d5a9ee7e8$var$load("hhss7"),
    $1218e04d5a9ee7e8$var$load("aQh37"),
    $1218e04d5a9ee7e8$var$load("bJVDE"),
    $1218e04d5a9ee7e8$var$load("8HygH"),
    $1218e04d5a9ee7e8$var$load("G9L45"),
    $1218e04d5a9ee7e8$var$load("kuFG2"),
    $1218e04d5a9ee7e8$var$load("2YX4L"),
    $1218e04d5a9ee7e8$var$load("10E5t"),
    $1218e04d5a9ee7e8$var$load("h3ABO"),
    $1218e04d5a9ee7e8$var$load("kC80R"),
    $1218e04d5a9ee7e8$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("6n8oj"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("6n8oj", function(module, exports) {

let $4a3b66616da4cd40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4a3b66616da4cd40$var$load("cnl5R"),
    $4a3b66616da4cd40$var$load("2qnH2"),
    $4a3b66616da4cd40$var$load("b9CA3"),
    $4a3b66616da4cd40$var$load("2YffH"),
    $4a3b66616da4cd40$var$load("lUDr0"),
    $4a3b66616da4cd40$var$load("8dwgS"),
    $4a3b66616da4cd40$var$load("9XOeB"),
    $4a3b66616da4cd40$var$load("xu7ej"),
    $4a3b66616da4cd40$var$load("iQ4FP"),
    $4a3b66616da4cd40$var$load("71gca"),
    $4a3b66616da4cd40$var$load("cp5Kz"),
    $4a3b66616da4cd40$var$load("82Jpo"),
    $4a3b66616da4cd40$var$load("bDpLy"),
    $4a3b66616da4cd40$var$load("d2YjW"),
    $4a3b66616da4cd40$var$load("im1VN"),
    $4a3b66616da4cd40$var$load("eFu2n"),
    $4a3b66616da4cd40$var$load("czOM6"),
    $4a3b66616da4cd40$var$load("jWHz7"),
    $4a3b66616da4cd40$var$load("7o9KM"),
    $4a3b66616da4cd40$var$load("j8WjL"),
    $4a3b66616da4cd40$var$load("f1rEg"),
    $4a3b66616da4cd40$var$load("k7tiZ"),
    $4a3b66616da4cd40$var$load("9anPW"),
    $4a3b66616da4cd40$var$load("b2FtX"),
    $4a3b66616da4cd40$var$load("gnDXu"),
    $4a3b66616da4cd40$var$load("dl2qY"),
    $4a3b66616da4cd40$var$load("kL5FA"),
    $4a3b66616da4cd40$var$load("6iz6l"),
    $4a3b66616da4cd40$var$load("4SCW2"),
    $4a3b66616da4cd40$var$load("9q75n"),
    $4a3b66616da4cd40$var$load("iYHbd"),
    $4a3b66616da4cd40$var$load("3q2Ng"),
    $4a3b66616da4cd40$var$load("jRpDi"),
    $4a3b66616da4cd40$var$load("5wVuh"),
    $4a3b66616da4cd40$var$load("4NznW"),
    $4a3b66616da4cd40$var$load("41PFq"),
    $4a3b66616da4cd40$var$load("jE9nA"),
    $4a3b66616da4cd40$var$load("c0JsV"),
    $4a3b66616da4cd40$var$load("h3ABO"),
    $4a3b66616da4cd40$var$load("3b4Vy"),
    $4a3b66616da4cd40$var$load("jyDas"),
    $4a3b66616da4cd40$var$load("1oHTu"),
    $4a3b66616da4cd40$var$load("juJ52"),
    $4a3b66616da4cd40$var$load("8HygH"),
    $4a3b66616da4cd40$var$load("G9L45"),
    $4a3b66616da4cd40$var$load("6wr18"),
    $4a3b66616da4cd40$var$load("jvHRs"),
    $4a3b66616da4cd40$var$load("9XYQ9"),
    $4a3b66616da4cd40$var$load("Wowvf"),
    $4a3b66616da4cd40$var$load("2tIxk"),
    $4a3b66616da4cd40$var$load("dLq4a"),
    $4a3b66616da4cd40$var$load("ffEVr"),
    $4a3b66616da4cd40$var$load("hhss7"),
    $4a3b66616da4cd40$var$load("aQh37"),
    $4a3b66616da4cd40$var$load("bJVDE"),
    $4a3b66616da4cd40$var$load("2YX4L"),
    $4a3b66616da4cd40$var$load("10E5t"),
    $4a3b66616da4cd40$var$load("jnVKv"),
    $4a3b66616da4cd40$var$load("7EorR"),
    $4a3b66616da4cd40$var$load("bgHzk"),
    $4a3b66616da4cd40$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.087e06e2.js.map
